import React from 'react';

const ProductSearchFilters = ({ 
  filters, 
  onFilterChange, 
  onSortChange,
  onSearch 
}) => {
  const { sourceSite, status, published_to_shopify, sortBy, sortOrder } = filters;

  const handleFilterChange = (key, value) => {
    onFilterChange(key, value);
  };

  const handleSortChange = (key, value) => {
    onSortChange(key, value);
  };

  const handleSearch = () => {
    onSearch();
  };


  return (
    <div className="bg-gray-50 p-4 rounded-lg mb-4">
      {/* 데스크톱 레이아웃 */}
      <div className="hidden md:flex justify-between items-center">
        <div className="flex flex-wrap gap-5">
          {/* 사이트 필터 */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              사이트
            </label>
            <select
              value={sourceSite}
              onChange={(e) => handleFilterChange('sourceSite', e.target.value)}
              className="w-30 px-2 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">전체</option>
              <option value="oliveyoung">올리브영</option>
              <option value="musinsa">무신사</option>
              <option value="weverse">위버스</option>
              <option value="ktown">케이타운</option>
            </select>
          </div>

          {/* 상태 필터 */}
          {/* <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              상태
            </label>
            <select
              value={status}
              onChange={(e) => handleFilterChange('status', e.target.value)}
              className="w-30 px-2 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">전체</option>
              <option value="draft">초안</option>
              <option value="active">활성</option>
              <option value="archived">아카이브</option>
            </select>
          </div> */}

          {/* 게시 여부 필터 */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              게시 여부
            </label>
            <select
              value={published_to_shopify}
              onChange={(e) => handleFilterChange('published_to_shopify', e.target.value)}
              className="w-30 px-2 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">전체</option>
              <option value="false">미게시</option>
              <option value="true">게시</option>
            </select>
          </div>

          {/* 정렬 기준 */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              정렬 기준
            </label>
            <select
              value={sortBy}
              onChange={(e) => handleSortChange('sortBy', e.target.value)}
              className="px-2 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="crawled_at">크롤링일시</option>
              <option value="title">상품명</option>
              <option value="updated_at">업데이트일시</option>
            </select>
          </div>

          {/* 정렬 순서 */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              정렬 순서
            </label>
            <select
              value={sortOrder}
              onChange={(e) => handleSortChange('sortOrder', e.target.value)}
              className="px-2 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="desc">내림차순</option>
              <option value="asc">오름차순</option>
            </select>
          </div>
        </div>

        {/* 검색 버튼 */}
        <div className="flex justify-end">
          <button
            onClick={handleSearch}
            className="h-10 px-3 py-2 bg-slate-600 text-white rounded-md hover:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors text-sm"
          >
            검색
          </button>
        </div>
      </div>

      {/* 모바일 레이아웃 */}
      <div className="md:hidden space-y-4">
        {/* 첫 번째 행: 사이트, 상태 */}
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">
              사이트
            </label>
            <select
              value={sourceSite}
              onChange={(e) => handleFilterChange('sourceSite', e.target.value)}
              className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">전체</option>
              <option value="oliveyoung">올리브영</option>
              <option value="musinsa">무신사</option>
              <option value="weverse">위버스</option>
              <option value="ktown">케이타운</option>
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">
              상태
            </label>
            <select
              value={status}
              onChange={(e) => handleFilterChange('status', e.target.value)}
              className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">전체</option>
              <option value="draft">초안</option>
              <option value="active">활성</option>
              <option value="archived">아카이브</option>
            </select>
          </div>
        </div>

        {/* 두 번째 행: 게시 여부, 정렬 기준 */}
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">
              게시 여부
            </label>
            <select
              value={published_to_shopify}
              onChange={(e) => handleFilterChange('published_to_shopify', e.target.value)}
              className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">전체</option>
              <option value="false">미게시</option>
              <option value="true">게시</option>
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">
              정렬 기준
            </label>
            <select
              value={sortBy}
              onChange={(e) => handleSortChange('sortBy', e.target.value)}
              className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="crawled_at">크롤링일시</option>
              <option value="title">상품명</option>
              <option value="updated_at">업데이트일시</option>
            </select>
          </div>
        </div>

        {/* 세 번째 행: 정렬 순서, 검색 버튼 */}
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">
              정렬 순서
            </label>
            <select
              value={sortOrder}
              onChange={(e) => handleSortChange('sortOrder', e.target.value)}
              className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="desc">내림차순</option>
              <option value="asc">오름차순</option>
            </select>
          </div>
          <div className="flex items-end">
            <button
              onClick={handleSearch}
              className="w-full h-8 px-3 py-1 bg-slate-600 text-white text-xs rounded-md hover:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors"
            >
              검색
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductSearchFilters;
